var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "modal-modify-third-confirm-add-other",
      "centered": "",
      "no-close-on-backdrop": "",
      "no-enforce-focus": "",
      "header-class": "py-50",
      "size": "lg"
    },
    on: {
      "show": _vm.handleShowModal,
      "hide": _vm.handleHideModal
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('div', {
          staticClass: "w-100 d-flex justify-content-between align-items-center"
        }, [_c('div', {
          staticClass: "text-airline fw_700",
          class: _vm.isMobileView ? 'font-medium-1' : 'font-medium-3'
        }, [_vm._v(" " + _vm._s(_vm.$t('reservation.payment')) + " ")]), _c('b-button', {
          staticClass: "p-50",
          attrs: {
            "variant": "flat-secondary"
          },
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "XIcon",
            "size": "24"
          }
        })], 1)], 1)];
      }
    }, {
      key: "modal-footer",
      fn: function fn(_ref2) {
        var close = _ref2.close;
        return [_c('b-button', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(186, 191, 199, 0.15)',
            expression: "'rgba(186, 191, 199, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "px-1 px-md-2",
          attrs: {
            "variant": "outline-secondary",
            "pill": ""
          },
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('reservation.back')) + " ")]), _c('b-button', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(113, 102, 240, 0.15)',
            expression: "'rgba(113, 102, 240, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "fw-700",
          attrs: {
            "variant": ['QH', 'TH', 'AK'].includes(_vm.bookingSource) || _vm.isPayNow ? 'success' : 'warning',
            "pill": "",
            "disabled": !_vm.isConfirm
          },
          on: {
            "click": _vm.handleConfirm
          }
        }, [_vm._v(" " + _vm._s(['QH', 'TH', 'AK'].includes(_vm.bookingSource) || _vm.isPayNow ? _vm.$t('reservation.payNow') : _vm.$t('reservation.payLater')) + " ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "fw-700 mb-25"
  }, [_vm._v(" " + _vm._s(_vm.$t('reservation.confirmInformation')) + " ")]), _vm._l(_vm.dataShow, function (segmentData, indexSegmentData) {
    return _c('b-card', {
      key: indexSegmentData,
      staticClass: "border-warning mb-50",
      attrs: {
        "header-bg-variant": "light-warning",
        "header-class": "p-50",
        "body-class": "py-25 px-1"
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function fn() {
          return [_c('div', {
            staticClass: "text-airline fw_700"
          }, [_c('span', {
            staticClass: "font-small-4"
          }, [_vm._v(_vm._s(_vm.$t('reservation.itinerary')) + " ")]), _vm._v(" " + _vm._s(_vm.resolveHeaderTrip(segmentData)) + " ")])];
        },
        proxy: true
      }], null, true)
    }, [_c('CardNamePax', {
      attrs: {
        "arr-pax": segmentData.arrPax,
        "name-type": _vm.$t('reservation.service')
      }
    }), _c('div', {
      staticClass: "mb-50"
    }, [_c('span', {
      staticClass: "fw-700"
    }, [_vm._v(_vm._s(_vm.$t('reservation.selectedPackage')))]), _vm._l(segmentData.newAddItems, function (otherItem, itemOtherItem) {
      return _c('div', {
        key: itemOtherItem,
        staticClass: "mb-25"
      }, [_c('div', [_vm._v(_vm._s("- ".concat(_vm.resolveSsrNameByCode(['TR', 'JQ'].includes(_vm.bookingSource) ? "".concat(_vm.bookingSource, "_").concat(otherItem.code) : otherItem.code), " x").concat(otherItem.quantity)))])]);
    })], 2)], 1);
  }), _c('b-card', {
    attrs: {
      "header-class": "p-1",
      "no-body": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('b-row', {
          staticClass: "w-100 d-flex-between mx-1 mx-lg-3"
        }, [_c('b-col', {
          staticClass: "text-right font-medium-3 fw_700",
          attrs: {
            "cols": "6"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('reservation.totalAmount')) + ": ")]), _c('b-col', {
          staticClass: "font-medium-3 text-warning fw_700 text-right",
          attrs: {
            "cols": "6"
          }
        }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.totalPrice)) + " ")])], 1)];
      },
      proxy: true
    }])
  }), _vm.getBookingData && ['VJ'].includes(_vm.bookingSource) ? _c('div', {
    staticClass: "fw-700 mb-25"
  }, [_vm._v(" " + _vm._s(_vm.$t('reservation.paymentMethodSelection')) + " ")]) : _vm._e(), _vm.getBookingData && ['VJ'].includes(_vm.bookingSource) ? _c('CardAncillaryPayOptions', {
    attrs: {
      "reservations-data": _vm.getBookingData,
      "is-pay-now": _vm.isPayNow,
      "has-paid-trip": _vm.hasPaidTrip
    },
    on: {
      "update:isPayNow": function updateIsPayNow($event) {
        _vm.isPayNow = $event;
      },
      "update:is-pay-now": function updateIsPayNow($event) {
        _vm.isPayNow = $event;
      }
    }
  }) : _vm._e(), _c('IAmConfirm', {
    attrs: {
      "is-confirm": _vm.isConfirm
    },
    on: {
      "update:isConfirm": function updateIsConfirm($event) {
        _vm.isConfirm = $event;
      },
      "update:is-confirm": function updateIsConfirm($event) {
        _vm.isConfirm = $event;
      }
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }